/**
 * Build-time environment variable helpers
 * These functions parse environment variables at build time (before Zod validation)
 * Use these in vite.config.ts, +config.ts, and other build-time configuration files
 */

/**
 * Parse boolean from environment variable at build time
 * Handles: "true"/"false", "1"/"0", "yes"/"no", "on"/"off", undefined
 */
export function parseBuildTimeBoolean(value: string | undefined): boolean {
  if (!value || value === "") return false;
  const normalized = value.toLowerCase().trim();
  return (
    normalized === "true" ||
    normalized === "1" ||
    normalized === "yes" ||
    normalized === "on"
  );
}

/**
 * Check if multilingual mode is enabled at build time
 */
export function isBuildTimeMultilingual(): boolean {
  return parseBuildTimeBoolean(process.env.VITE_MULTILINGUAL);
}

/**
 * Get default locale at build time
 */
export function getBuildTimeDefaultLocale(): string {
  return process.env.VITE_DEFAULT_LOCALE || "en";
}
